import { GetServerSideProps, GetStaticProps } from "next";
import { useState } from "react";
import ContentContainer from "@/src/components/containers/ContentContainer";
import { Typography } from "@material-tailwind/react";
import SubScribeCards from "@/src/components/cards/SubscribeCards";
import GenericHead from "@/src/components/Head/GenericHead";
import { getCookie } from "cookies-next";
import { checkUserSubscription } from "@/src/utils/stripe";

export interface SubscribePageProps {
  accountsubs: string[];
}

const SubscribePage = ({ accountsubs }: SubscribePageProps) => {
  return (
    <>
      <GenericHead />
      <ContentContainer>
        <div className="flex-col items-center flex">
          <Typography variant="h1">Subscribe</Typography>
          <Typography variant="paragraph">
            Access the best of what SC Playbook has to offer with our premium
            content
          </Typography>
          <div style={{ marginBottom: "2rem" }}></div>
          <SubScribeCards activeSubscriptionProductIds={accountsubs} />
        </div>
      </ContentContainer>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const userEmail = await getCookie("userEmail", {
    req: context.req,
    res: context.res,
  });
  //@ts-ignore
  const subs = await checkUserSubscription(userEmail);
  return {
    props: {
      //@ts-ignore
      accountsubs: subs.map(function (sub) {
        return sub.id;
      }),
    },
  };
};

export default SubscribePage;
